var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape39(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 74,
    viewBox: "0 0 93 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1324 39.5797C61.2967 39.4805 69.4451 40.3235 77.4161 42.092C89.2327 45.0053 91.0239 49.4241 91.0239 51.8028C91.0239 54.1815 89.2416 58.6004 77.4161 61.5137C61.4034 64.864 44.8703 64.864 28.8577 61.5137C17.0411 58.6004 15.2588 54.1815 15.2588 51.8028C15.2588 49.4241 17.0411 45.0053 28.8577 42.092C36.8258 40.3249 44.9711 39.4819 53.1324 39.5797Z",
    fill: "#FDFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.06
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5883 40.3101C60.5219 40.2144 68.44 41.0334 76.1858 42.7512C87.6548 45.5664 89.4193 49.8784 89.4193 52.168C89.4193 54.4576 87.637 58.7696 76.1858 61.5848C60.6111 64.8447 44.5299 64.8447 28.9552 61.5848C17.4772 58.7696 15.7217 54.4576 15.7217 52.168C15.7217 49.8784 17.5039 45.5664 28.9552 42.7512C36.7125 41.0298 44.6428 40.2107 52.5883 40.3101Z",
    fill: "#FAFBFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0463 41.0404C59.7515 40.9481 67.4419 41.7402 74.9665 43.4013C86.0969 46.1364 87.8257 50.2791 87.8257 52.533C87.8257 54.787 86.0969 58.9297 74.9665 61.6648C59.8485 64.8126 44.2439 64.8126 29.126 61.6648C17.9955 58.9297 16.2578 54.7781 16.2578 52.533C16.2578 50.288 18.0401 46.1364 29.126 43.4013C36.6505 41.7402 44.341 40.9481 52.0463 41.0404Z",
    fill: "#F8F9FD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5017 41.8066C58.9916 41.7159 66.4669 42.4872 73.7804 44.1051C84.5632 46.7778 86.2564 50.7601 86.2564 52.9428C86.2564 55.1255 84.5454 59.1791 73.7804 61.7806C59.1089 64.8334 43.9659 64.8334 29.2944 61.7806C18.5115 59.1079 16.8184 55.1255 16.8184 52.9428C16.8184 50.7601 18.5294 46.7065 29.2944 44.1051C36.5846 42.4926 44.0357 41.7214 51.5017 41.8066Z",
    fill: "#F6F7FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9596 42.4927C58.2092 42.4089 65.4446 43.1531 72.5252 44.711C82.9694 47.259 84.6448 51.1433 84.6448 53.2636C84.6448 55.384 82.9694 59.2594 72.5252 61.8074C58.3034 64.7653 43.6247 64.7653 29.4028 61.8074C18.9587 59.2594 17.2744 55.384 17.2744 53.2636C17.2744 51.1433 18.9587 47.259 29.4028 44.711C36.4804 43.1531 43.7129 42.4088 50.9596 42.4927Z",
    fill: "#F3F5FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.414 43.2231C57.4354 43.1433 64.443 43.8606 71.3025 45.3612C81.3992 47.829 83.0567 51.5976 83.0567 53.6288C83.0567 55.6601 81.3992 59.4196 71.3025 61.8875C57.5258 64.7383 43.3112 64.7383 29.5345 61.8875C19.4378 59.4196 17.7803 55.6512 17.7803 53.6288C17.7803 51.6065 19.4378 47.829 29.5345 45.3612C36.3909 43.8604 43.3957 43.1431 50.414 43.2231Z",
    fill: "#F1F3FB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8722 43.9538C56.666 43.8713 63.447 44.5648 70.0834 46.0207C79.886 48.3905 81.4633 51.9987 81.4633 53.9854C81.4633 55.9721 79.8414 59.5892 70.0834 62.0036C56.7532 64.7587 43.0001 64.7587 29.6699 62.0036C19.9119 59.6338 18.29 56.0256 18.29 53.9854C18.29 51.9453 19.9119 48.3905 29.6699 46.0207C36.3034 44.5652 43.0814 43.8717 49.8722 43.9538Z",
    fill: "#EFF1FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3354 44.6842C55.898 44.6061 62.4482 45.2727 68.8604 46.6709C78.2709 48.9605 79.866 52.435 79.866 54.3505C79.866 56.2659 78.2709 59.7493 68.8604 62.0389C55.9756 64.6878 42.6864 64.6878 29.8016 62.0389C20.3911 59.7493 18.7959 56.2748 18.7959 54.3505C18.7959 52.4261 20.3911 48.9605 29.8016 46.6709C36.2167 45.2722 42.7699 44.6057 49.3354 44.6842Z",
    fill: "#ECEFFA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7931 45.415C55.1189 45.341 61.4329 45.9836 67.614 47.3305C76.677 49.5221 78.2543 52.863 78.2543 54.7161C78.2543 56.5691 76.677 59.9189 67.614 62.1106C55.1787 64.6646 42.3539 64.6646 29.9186 62.1106C20.8467 59.9189 19.2783 56.5781 19.2783 54.7161C19.2783 52.8541 20.8467 49.5221 29.9186 47.3305C36.1172 45.9795 42.4493 45.3369 48.7931 45.415Z",
    fill: "#EAEDF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2489 46.1364C54.3557 46.0673 60.4509 46.6859 66.4193 47.9806C75.1435 50.092 76.6852 53.326 76.6852 55.1078C76.6852 56.8896 75.1435 60.1057 66.4193 62.235C54.4305 64.6938 42.0672 64.6938 30.0785 62.235C21.3542 60.1325 19.8125 56.8896 19.8125 55.1078C19.8125 53.326 21.3542 50.1188 30.0785 47.9806C36.0467 46.6849 42.142 46.0663 48.2489 46.1364Z",
    fill: "#E8EBF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7055 46.867C53.5849 46.8024 59.453 47.4001 65.1986 48.6488C73.5754 50.6622 75.0904 53.727 75.0904 55.4553C75.0904 57.1837 73.5754 60.2484 65.1986 62.2707C53.6483 64.6351 41.7395 64.6442 30.1856 62.2975C21.8089 60.2751 20.2939 57.2104 20.2939 55.482C20.2939 53.7537 21.8089 50.689 30.1856 48.6755C35.939 47.4159 41.8161 46.8092 47.7055 46.867Z",
    fill: "#E5E9F8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1624 47.5978C52.8133 47.5339 58.4536 48.1017 63.9783 49.2906C71.9985 51.2149 73.5046 54.1548 73.5046 55.8119C73.5046 57.469 72.0164 60.409 63.9783 62.3333C52.8843 64.5904 41.4493 64.5904 30.3554 62.3333C22.3351 60.409 20.8291 57.469 20.8291 55.8119C20.8291 54.1548 22.3173 51.2149 30.3554 49.2906C35.8771 48.1016 41.5145 47.5338 47.1624 47.5978Z",
    fill: "#E3E7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6187 48.3283C52.0416 48.2641 57.4546 48.8049 62.7574 49.9408C70.448 51.785 71.9095 54.5825 71.9095 56.1772C71.9095 57.7719 70.448 60.5693 62.7574 62.4135C52.1088 64.5635 41.1377 64.5635 30.489 62.4135C22.7984 60.5693 21.3369 57.7719 21.3369 56.1772C21.3369 54.5825 22.7984 51.785 30.489 49.9408C35.7888 48.8048 41.1989 48.264 46.6187 48.3283Z",
    fill: "#E1E5F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.075 49.0585C51.27 48.9959 56.4558 49.5128 61.5362 50.5997C68.8881 52.3815 70.3229 55.0542 70.3229 56.542C70.3229 58.0298 68.8881 60.7382 61.5362 62.4844C51.3342 64.5393 40.8246 64.5393 30.6226 62.4844C23.2707 60.7026 21.8359 58.0298 21.8359 56.542C21.8359 55.0542 23.2707 52.3459 30.6226 50.5997C35.7 49.5133 40.8829 48.9963 46.075 49.0585Z",
    fill: "#DEE3F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5402 49.8249C50.5044 49.7698 55.4594 50.2628 60.3154 51.2949C67.3198 52.9609 68.7278 55.4821 68.7278 56.9521C68.7278 58.4221 67.3198 60.9434 60.3154 62.6004C50.5628 64.5604 40.5176 64.5604 30.7651 62.6004C23.7518 60.9434 22.3438 58.4132 22.3438 56.9521C22.3438 55.491 23.7518 52.9609 30.7651 51.2949C35.6209 50.2619 40.576 49.7689 45.5402 49.8249Z",
    fill: "#DCE1F5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9971 50.5111C49.7335 50.4578 54.4614 50.9269 59.095 51.9098C65.7607 53.4778 67.1153 55.8744 67.1153 57.2553C67.1153 58.6362 65.7429 61.0416 59.095 62.6007C49.7878 64.4537 40.2064 64.4537 30.8992 62.6007C24.2334 61.0238 22.8789 58.6362 22.8789 57.2553C22.8789 55.8744 24.2602 53.46 30.8992 51.9098C35.5328 50.9269 40.2606 50.4578 44.9971 50.5111Z",
    fill: "#DADEF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.443 51.2415C48.9512 51.1918 53.4514 51.6339 57.8637 52.56C64.1819 54.0389 65.5364 56.3018 65.5364 57.6381C65.5364 58.9745 64.1819 61.2017 57.8637 62.7073C49.003 64.4655 39.8831 64.4655 31.0224 62.7073C24.7041 61.2285 23.3496 58.9656 23.3496 57.6381C23.3496 56.3107 24.7041 54.0745 31.0224 52.56C35.4346 51.6339 39.9348 51.1918 44.443 51.2415Z",
    fill: "#D8DCF4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9091 51.9718C48.189 51.9262 52.4614 52.3413 56.6524 53.2102C62.6231 54.6089 63.9509 56.7738 63.9509 57.9943C63.9509 59.2149 62.6231 61.3887 56.6524 62.7874C48.2371 64.4386 39.581 64.4386 31.1657 62.7874C25.195 61.3887 23.8672 59.2683 23.8672 57.9943C23.8672 56.7203 25.195 54.6089 31.1657 53.2102C35.3568 52.342 39.6292 51.9268 43.9091 51.9718Z",
    fill: "#D5DAF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3652 52.7024C47.4174 52.6589 51.4626 53.0502 55.4313 53.8695C61.0634 55.1702 62.3555 57.1658 62.3555 58.324C62.3555 59.4822 61.0634 61.5223 55.4313 62.7785C47.4656 64.3345 39.2739 64.3345 31.3081 62.7785C25.6761 61.4778 24.375 59.4822 24.375 58.324C24.375 57.1658 25.6761 55.1346 31.3081 53.8695C35.2738 53.0502 39.316 52.6589 43.3652 52.7024Z",
    fill: "#D3D8F3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.822 53.4329C46.6581 53.386 50.4882 53.7504 54.2465 54.5198C59.531 55.7403 60.8054 57.5934 60.8054 58.7248C60.8054 59.8562 59.531 61.7183 54.2465 62.9299C46.7272 64.39 38.9971 64.39 31.4778 62.9299C26.1933 61.7183 24.9189 59.8652 24.9189 58.7248C24.9189 57.5845 26.1933 55.7403 31.4778 54.5198C35.2099 53.7559 39.0127 53.3915 42.822 53.4329Z",
    fill: "#D1D6F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2874 54.1547C45.8783 54.1162 49.463 54.4597 52.9812 55.1793C57.927 56.3018 59.1657 58.0212 59.1657 59.0903C59.1657 60.1594 57.927 61.8788 52.9812 63.0102C45.916 64.3609 38.6589 64.3609 31.5937 63.0102C26.6479 61.8788 25.4092 60.1594 25.4092 59.0903C25.4092 58.0212 26.6479 56.3018 31.5937 55.1793C35.1119 54.4599 38.6966 54.1164 42.2874 54.1547Z",
    fill: "#CED4F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.71
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7704 54.8852C45.136 54.8497 48.496 55.1663 51.7957 55.8296C56.3941 56.863 57.615 58.4489 57.615 59.4556C57.615 60.4623 56.3941 62.057 51.7957 63.0816C45.1715 64.3407 38.3692 64.3407 31.745 63.0816C27.1378 62.057 25.9258 60.4623 25.9258 59.4556C25.9258 58.4489 27.1378 56.863 31.745 55.8296C35.0446 55.1658 38.4048 54.8493 41.7704 54.8852Z",
    fill: "#CCD2F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2005 55.6155C44.3389 55.5884 47.4717 55.887 50.5486 56.5064C54.8082 57.4508 55.9935 58.9119 55.9935 59.8473C55.9935 60.7827 54.8082 62.2438 50.5486 63.1882C44.364 64.3425 38.0191 64.3425 31.8345 63.1882C27.5749 62.2438 26.3896 60.7827 26.3896 59.8473C26.3896 58.9119 27.5749 57.4508 31.8345 56.5064C34.9171 55.8853 38.056 55.5868 41.2005 55.6155Z",
    fill: "#CAD0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6565 56.3462C43.5664 56.3126 46.4719 56.5783 49.3274 57.1392C53.2395 57.9855 54.398 59.3129 54.398 60.186C54.398 61.0591 53.2395 62.3865 49.3274 63.2329C43.5952 64.2901 37.7179 64.2901 31.9857 63.2329C28.0735 62.3865 26.915 61.0591 26.915 60.186C26.915 59.3129 28.0735 57.9855 31.9857 57.1392C34.8411 56.5783 37.7467 56.3126 40.6565 56.3462Z",
    fill: "#C7CEF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1135 57.0769C42.8041 57.0449 45.491 57.2837 48.1338 57.7896C51.6983 58.5558 52.839 59.7407 52.839 60.5514C52.839 61.3621 51.7073 62.5471 48.1338 63.3043C42.8482 64.2665 37.4322 64.2665 32.1467 63.3043C28.5821 62.5471 27.4414 61.3621 27.4414 60.5514C27.4414 59.7407 28.5821 58.5558 32.1467 57.7896C34.7719 57.2872 37.4408 57.0485 40.1135 57.0769Z",
    fill: "#C5CCEF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5691 57.8432C42.0234 57.818 44.4741 58.0358 46.8854 58.4936C50.1114 59.1618 51.2164 60.2131 51.2164 60.9614C51.2164 61.7098 50.1114 62.7432 46.8854 63.4292C42.0484 64.2845 37.0988 64.2845 32.2617 63.4292C29.0269 62.7522 27.9219 61.7009 27.9219 60.9614C27.9219 60.222 29.0269 59.1796 32.2617 58.4936C34.67 58.0357 37.1178 57.8179 39.5691 57.8432Z",
    fill: "#C3CAEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0254 58.5289C41.2515 58.5072 43.4746 58.6981 45.6644 59.099C48.5518 59.687 49.6301 60.6047 49.6301 61.2817C49.6301 61.9588 48.5518 62.8765 45.6644 63.4555C41.2741 64.2158 36.7856 64.2158 32.3953 63.4555C29.5079 62.8765 28.4297 61.9588 28.4297 61.2817C28.4297 60.6047 29.5079 59.687 32.3953 59.099C34.5821 58.6985 36.8022 58.5076 39.0254 58.5289Z",
    fill: "#C0C8EE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4912 59.2594C40.4866 59.2403 42.4796 59.4073 44.444 59.7583C46.9838 60.2483 48.0086 61.0323 48.0086 61.647C48.0086 62.2618 46.957 63.0369 44.444 63.5358C40.4994 64.1891 36.4741 64.1891 32.5294 63.5358C29.9897 63.0369 28.9648 62.2529 28.9648 61.647C28.9648 61.0412 30.0164 60.2483 32.5294 59.7583C34.4969 59.4074 36.4927 59.2404 38.4912 59.2594Z",
    fill: "#BEC6ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.94
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9468 59.9898C39.7142 59.9748 41.4795 60.1149 43.2224 60.4086C45.4146 60.8184 46.4394 61.4598 46.4394 62.0033C46.4394 62.5467 45.4146 63.1971 43.2224 63.6069C39.7275 64.1652 36.1661 64.1652 32.6712 63.6069C30.4701 63.1971 29.4453 62.5557 29.4453 62.0033C29.4453 61.4509 30.4701 60.8184 32.6712 60.4086C34.414 60.1142 36.1794 59.9741 37.9468 59.9898Z",
    fill: "#BCC4EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.97
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4041 60.7206C38.9435 60.7092 40.4813 60.8224 42.0024 61.0592C43.856 61.3888 44.8541 61.8877 44.8541 62.3688C44.8541 62.8499 43.856 63.3577 42.0024 63.6785C38.9544 64.1417 35.8538 64.1417 32.8058 63.6785C30.9522 63.3577 29.9541 62.8499 29.9541 62.3688C29.9541 61.8877 30.9522 61.3888 32.8058 61.0592C34.3269 60.8224 35.8647 60.7092 37.4041 60.7206Z",
    fill: "#B9C2EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2588 62.7339C43.2588 63.4466 40.3982 64.0257 36.8603 64.0257C33.3225 64.0257 30.4619 63.4466 30.4619 62.7339C30.4619 62.0212 33.3225 61.451 36.8603 61.451C40.3982 61.451 43.2588 62.0212 43.2588 62.7339Z",
    fill: "#B7C0EB"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7248 60.8758C62.9907 53.7796 67.9906 37.2757 60.8924 24.0135C53.7942 10.7512 37.2858 5.75268 24.02 12.8489C10.7541 19.9452 5.75423 36.4491 12.8524 49.7113C19.9506 62.9736 36.459 67.9721 49.7248 60.8758Z",
    fill: "url(#paint0_linear_476_3259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_3259",
    x1: 24.02,
    y1: 12.8489,
    x2: 49.714,
    y2: 60.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape39);
export default __webpack_public_path__ + "static/media/shape_39.1e65b8ec073a73b7274735a6586584d8.svg";
export { ForwardRef as ReactComponent };